import type { RunResult } from '../games/nganya/types';
import { gameProfileService } from './GameProfileService';

/**
 * Local score recorder. Labels all results as local demo.
 * Future Laravel: POST /api/games/nganya/sessions + /scores
 */
export class LocalGameScoreService {
  record(partial: Omit<RunResult, 'bestScore' | 'isLocalDemo' | 'newAchievements'>): RunResult {
    const draft: RunResult = {
      ...partial,
      bestScore: 0,
      isLocalDemo: true,
      newAchievements: [],
    };
    const { progress, newAchievements } = gameProfileService.applyRun(draft);
    return {
      ...draft,
      bestScore: progress.bestScore,
      newAchievements,
    };
  }
}

export const gameScoreService = new LocalGameScoreService();
